module.exports = __webpack_public_path__ + "img/forbidden.fd376f40.png";